require('./cardStatementList.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
//@core
const { getLanguage } = require('core/i18n').i18n;
// @ helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const language = getLanguage();

class CardStatementList extends React.Component {
    buildOutstandingBalance(immStatementDetails) {
        const settlementDetails = [
            {
                translationKey: 'cardStatement-previousBalance',
                value: immStatementDetails.get('previousBalance')
            },
            {
                translationKey: 'cardStatement-totalMovements',
                value: immStatementDetails.get('totalMovements')
            },
            {
                translationKey: 'cardStatement-totalBalance',
                value: immStatementDetails.get('totalBalance')
            },
            {
                translationKey: 'cardStatement-amortizedFee',
                value: immStatementDetails.get('amortizedFee')
            },
            {
                translationKey: 'cardStatement-outstandingBalance',
                value: immStatementDetails.get('outstandingBalance')
            }
        ];

        return settlementDetails.map(detail => (
            <OKInformativeListItem
                title={detail.translationKey}
                key={detail.translationKey}
            >
                <OneLineSymbolAmount
                    amountObject={getPlainAmountObject(detail.value)}
                    className="card-statementlist__value"
                    language={language}
                    amountObjectFormatted={formatAmountObject(detail.value)}
                />
            </OKInformativeListItem>
        ));
    }

    buildSettlementDetails(immStatementDetails, immCard) {
        const settlementDetails = [
            {
                translationKey: 'cardStatement-writtenOffAccount',
                value: immStatementDetails.get('writtenOffAccount')
            },
            {
                translationKey: 'cardStatement-charges',
                value: immStatementDetails.get('charges')
            },
            {
                translationKey: 'cardStatement-interests',
                value: immStatementDetails.get('interests')
            }
        ];

        if (!immCard.get('isViaT')) {
            settlementDetails.push(
                {
                    translationKey: 'cardStatement-totalBonus',
                    value: immStatementDetails.get('totalBonus')
                }
            );
        }

        settlementDetails.push(
            {
                translationKey: 'cardStatement-chargeImport',
                value: immStatementDetails.get('chargeImport')
            }
        );

        return settlementDetails.map(detail => (
            <OKInformativeListItem
                title={detail.translationKey}
                key={detail.translationKey}
            >
                <OneLineSymbolAmount
                    amountObject={getPlainAmountObject(detail.value)}
                    className="card-statementlist__value"
                    language={language}
                    amountObjectFormatted={formatAmountObject(detail.value)}
                />
            </OKInformativeListItem>
        ));
    }

    render() {
        const { immStatementDetails, immCard } = this.props;

        const settlementDetails = this.buildSettlementDetails(immStatementDetails, immCard);
        const outstandingBalance = this.buildOutstandingBalance(immStatementDetails);

        return (
            <OKSectionBox className="card-statementlist">
                <OKInformativeList title="cardStatement-settlement" columns={2}>
                    {settlementDetails}
                </OKInformativeList>
                <OKInformativeList title="cardStatement-outstandingBalanceCalculation" columns={2}>
                    {outstandingBalance}
                </OKInformativeList>
            </OKSectionBox>
        );
    }
}

CardStatementList.propTypes = {
    immStatementDetails: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired
};

module.exports = CardStatementList;